<template>
  <div style="height: calc(100vh - 160px)">
    <div class="filter-box">
      <a-input placeholder="请输入消息组名称" v-model="form.name" style="width: 150px; margin-right: 20px"></a-input>
      <a-select placeholder="请选择类型" mode="combobox" allowClear style="width: 150px; margin-right: 20px" v-model="form.type">
        <a-select-option v-for="(item, index) in typeOptions" :key="index" :value="item.value">{{ item.label }}</a-select-option>
      </a-select>
      <a-radio-group v-model="form.status">
        <a-radio-button v-for="(item, index) in statusOptions" :key="index" :value="item.value">{{ item.label }}</a-radio-button>
      </a-radio-group>
      <div class="button-box">
        <a-button class="filter_box_button" type="primary" @click="search">搜索</a-button>
        <a-button class="filter_box_button" @click="reset">重置</a-button>
      </div>
    </div>
    <div style="height: calc(100% - 100px)">
      <vxe-table :border="true" :data="dataSource" :height="tableHeight" resizable v-VXEtableDrag>
        <vxe-column field="id" title="消息组ID" width="100"></vxe-column>
        <vxe-column field="name" title="消息组名称" :min-width="100" show-overflow></vxe-column>
        <vxe-column field="description" title="备注" :min-width="350" show-overflow></vxe-column>
        <vxe-column field="Type" title="消息组类型" show-footer-overflow></vxe-column>
        <vxe-column field="Status" title="状态">
          <template #default="{ row }">
            {{ row.Status === 0 ? '归档' : '活跃' }}
          </template>
        </vxe-column>
        <vxe-column field="create_user" title="创建人" show-overflow></vxe-column>
        <vxe-column field="member" title="群组成员" :max-width="150">
          <template #default="{ row }">
            <a-tooltip>
              <template #title>{{ row.member ? row.member.join(',') : '' }}</template>
              <div style="width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ row.member ? row.member.join(',') : '' }}</div>
            </a-tooltip>
          </template>
        </vxe-column>
        <vxe-column field="operation" title="操作" width="210px">
          <template #default="{ row }">
            <div>
              <a-button @click="showDraw(row.id, row)" style="margin-right: 20px">查看</a-button>
              <a-button v-permission="PERMISSIONS.MESSAGE_GROUP_MANAGE" @click="showEdit(row.id, row)">编辑</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <a-pagination size="small" :total="pagination.total" :show-total="pagination.showTotal" @change="pageChange" style="margin-top: 20px; float: right" />
    <a-modal :visible="visible" title="编辑消息组" @ok="sumbit" @cancel="closeModal">
      <a-form :model="editForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="成员:" name="member">
          <a-select placeholder="请选择成员" allowClear mode="multiple" v-model="editForm.member" style="width: 150px; margin-right: 20px">
            <a-select-option v-for="(item, index) in memberOptions" :key="index" :value="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-drawer
      title="消息组详情"
      placement="right"
      width="33%"
      :closable="true"
      :visible="drawerVisible"
      :after-visible-change="drawerChange"
      @close="drawerVisible = false"
    >
      <a-form :model="detailsForm" layout="inline">
        <a-form-item label="消息组名称" name="name">
          <span class="click-span" @click="goMessageDetails(detailsForm.id, detailsForm)">{{ detailsForm.name }}</span>
        </a-form-item>
        <a-form-item label="备注" name="description">
          <div style="width: 25vw">{{ detailsForm.description }}</div>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>

<script>
import { fetchManagerGroup, updateGroupMember } from '@/api/notice'
import { getAllStaffs } from '@/api/user'
export default {
  name: 'messageManager',
  data() {
    return {
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      loading: false,
      form: {
        name: '',
        type: '',
        status: 1
      },
      typeOptions: [
        {
          value: 'lcl',
          label: 'lcl'
        }
      ],
      statusOptions: [
        { value: 0, label: '归档' },
        { value: 1, label: '活跃' }
      ],
      tableHeight: 'auto',
      visible: false,
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 14
      },
      memberOptions: [],
      editForm: {
        member: []
      },
      groupId: '',
      drawerVisible: false,
      detailsForm: {
        id: '',
        name: '',
        description: ''
      }
    }
  },
  async created() {
    await this.getUsers()
    await this.initFilter()
    await this.fetchTableData({
      page_num: this.pagination.current,
      page_size: this.pagination.pageSize,
      ...this.form
    })
  },
  methods: {
    initFilter() {
      this.form = {
        name: this.URL_FILTER.get('name', 'string', ''),
        type: this.URL_FILTER.get('type', 'string', ''),
        status: this.URL_FILTER.get('staus', 'number', 1)
      }
    },
    getUsers() {
      getAllStaffs().then(res => {
        this.memberOptions = res.data.map(item => {
          return {
            value: item.username,
            label: item.username
          }
        })
      })
    },
    fetchTableData(params) {
      this.loading = true
      fetchManagerGroup(params).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.dataSource = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleTableChange(pagination, filters) {
      this.pagination = pagination
      const params = {
        page_num: pagination.current,
        page_size: pagination.pageSize,
        ...filters,
        ...this.form
      }
      this.fetchTableData(params)
    },
    showDraw(id, record) {
      this.detailsForm = {
        name: record.name,
        description: record.description,
        id: record.id
      }
      this.drawerVisible = true
    },
    // 查看消息
    goMessageDetails(id, record) {
      this.$router.push({
        name: 'messageDetails',
        params: { group_id: [record.id] }
      })
    },
    // 编辑消息
    showEdit(id, record) {
      this.visible = true
      this.groupId = record.id
      this.$set(this.editForm, 'member', record.member ? record.member : [])
    },
    search() {
      this.URL_FILTER.set({ ...this.form })
      this.$set(this.pagination, 'current', 1)
      this.fetchTableData({
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize,
        ...this.form
      })
    },
    reset() {
      this.form = {
        name: '',
        type: '',
        status: 1
      }
      this.URL_FILTER.set({ ...this.form })
      this.$set(this.pagination, 'current', 1)
      this.$set(this.pagination, 'pageSize', 20)
      this.fetchTableData({
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize,
        ...this.form
      })
    },
    sumbit() {
      updateGroupMember(this.groupId, this.editForm).then(res => {
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.fetchTableData({
            page_num: this.pagination.current,
            page_size: this.pagination.pageSize,
            ...this.form
          })
        } else {
          this.$message.error(res.message)
        }
      })
      this.closeModal()
    },
    closeModal() {
      this.visible = false
      this.fetchTableData({
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize,
        ...this.form
      })
    },
    pageChange(current, pageSize) {
      this.fetchTableData({
        page_num: current,
        page_size: pageSize,
        ...this.form
      })
    },
    drawerChange() {}
  }
}
</script>

<style scoped>
.filter-box {
  margin-bottom: 20px;
}
.button-box {
  float: right;
}
.filter_box_button {
  margin-left: 10px;
}
</style>
<style>
.table-draggable-handle {
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
.resize-table-th {
  position: relative;
}
.click-span:hover {
  text-decoration: underline; /* 显示下划线 */
  color: blue; /* 鼠标悬浮时文本颜色为蓝色 */
  cursor: pointer;
}
.click-span {
  cursor: pointer;
}
</style>
